
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecc56"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecc56"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7b39cd18a2574dd0$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.59ab3562.js","atee1","atlon.5fa21094.png","leQTz","sms-service.72f930d1.png","cqEWq","any-sites.8cde7276.png","kkNrS","stockie.16cdb1ac.jpg","3n2ly","open.41d6bb34.png","22bZ8","yaft.e4b59bdd.png","4sU6e","carbon.0cb44833.jpg","1JhFm","monopoly.ad82aa0b.png"]'));

function $6f019d1f45ba2738$export$2e2bcd8739ae039(targetElements, defaultProps) {
    if (!targetElements.length) return;
    ScrollReveal({
        reset: false
    });
    targetElements.forEach(({ element: element, animation: animation })=>{
        ScrollReveal().reveal(element, Object.assign({}, defaultProps, animation));
    });
}


var $b5f6d4efc654cf78$exports = {};
"use strict";
var $b5f6d4efc654cf78$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
/**
 * Created by Sergiu Șandor (micku7zu) on 1/27/2017.
 * Original idea: https://github.com/gijsroge/tilt.js
 * MIT License.
 * Version 1.8.1
 */ var $b5f6d4efc654cf78$var$VanillaTilt = function() {
    function VanillaTilt(element) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $b5f6d4efc654cf78$var$classCallCheck(this, VanillaTilt);
        if (!(element instanceof Node)) throw "Can't initialize VanillaTilt because " + element + " is not a Node.";
        this.width = null;
        this.height = null;
        this.clientWidth = null;
        this.clientHeight = null;
        this.left = null;
        this.top = null;
        // for Gyroscope sampling
        this.gammazero = null;
        this.betazero = null;
        this.lastgammazero = null;
        this.lastbetazero = null;
        this.transitionTimeout = null;
        this.updateCall = null;
        this.event = null;
        this.updateBind = this.update.bind(this);
        this.resetBind = this.reset.bind(this);
        this.element = element;
        this.settings = this.extendSettings(settings);
        this.reverse = this.settings.reverse ? -1 : 1;
        this.resetToStart = VanillaTilt.isSettingTrue(this.settings["reset-to-start"]);
        this.glare = VanillaTilt.isSettingTrue(this.settings.glare);
        this.glarePrerender = VanillaTilt.isSettingTrue(this.settings["glare-prerender"]);
        this.fullPageListening = VanillaTilt.isSettingTrue(this.settings["full-page-listening"]);
        this.gyroscope = VanillaTilt.isSettingTrue(this.settings.gyroscope);
        this.gyroscopeSamples = this.settings.gyroscopeSamples;
        this.elementListener = this.getElementListener();
        if (this.glare) this.prepareGlare();
        if (this.fullPageListening) this.updateClientSize();
        this.addEventListeners();
        this.reset();
        if (this.resetToStart === false) {
            this.settings.startX = 0;
            this.settings.startY = 0;
        }
    }
    VanillaTilt.isSettingTrue = function isSettingTrue(setting) {
        return setting === "" || setting === true || setting === 1;
    };
    /**
   * Method returns element what will be listen mouse events
   * @return {Node}
   */ VanillaTilt.prototype.getElementListener = function getElementListener() {
        if (this.fullPageListening) return window.document;
        if (typeof this.settings["mouse-event-element"] === "string") {
            var mouseEventElement = document.querySelector(this.settings["mouse-event-element"]);
            if (mouseEventElement) return mouseEventElement;
        }
        if (this.settings["mouse-event-element"] instanceof Node) return this.settings["mouse-event-element"];
        return this.element;
    };
    /**
   * Method set listen methods for this.elementListener
   * @return {Node}
   */ VanillaTilt.prototype.addEventListeners = function addEventListeners() {
        this.onMouseEnterBind = this.onMouseEnter.bind(this);
        this.onMouseMoveBind = this.onMouseMove.bind(this);
        this.onMouseLeaveBind = this.onMouseLeave.bind(this);
        this.onWindowResizeBind = this.onWindowResize.bind(this);
        this.onDeviceOrientationBind = this.onDeviceOrientation.bind(this);
        this.elementListener.addEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.addEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.addEventListener("mousemove", this.onMouseMoveBind);
        if (this.glare || this.fullPageListening) window.addEventListener("resize", this.onWindowResizeBind);
        if (this.gyroscope) window.addEventListener("deviceorientation", this.onDeviceOrientationBind);
    };
    /**
   * Method remove event listeners from current this.elementListener
   */ VanillaTilt.prototype.removeEventListeners = function removeEventListeners() {
        this.elementListener.removeEventListener("mouseenter", this.onMouseEnterBind);
        this.elementListener.removeEventListener("mouseleave", this.onMouseLeaveBind);
        this.elementListener.removeEventListener("mousemove", this.onMouseMoveBind);
        if (this.gyroscope) window.removeEventListener("deviceorientation", this.onDeviceOrientationBind);
        if (this.glare || this.fullPageListening) window.removeEventListener("resize", this.onWindowResizeBind);
    };
    VanillaTilt.prototype.destroy = function destroy() {
        clearTimeout(this.transitionTimeout);
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.element.style.willChange = "";
        this.element.style.transition = "";
        this.element.style.transform = "";
        this.resetGlare();
        this.removeEventListeners();
        this.element.vanillaTilt = null;
        delete this.element.vanillaTilt;
        this.element = null;
    };
    VanillaTilt.prototype.onDeviceOrientation = function onDeviceOrientation(event) {
        if (event.gamma === null || event.beta === null) return;
        this.updateElementPosition();
        if (this.gyroscopeSamples > 0) {
            this.lastgammazero = this.gammazero;
            this.lastbetazero = this.betazero;
            if (this.gammazero === null) {
                this.gammazero = event.gamma;
                this.betazero = event.beta;
            } else {
                this.gammazero = (event.gamma + this.lastgammazero) / 2;
                this.betazero = (event.beta + this.lastbetazero) / 2;
            }
            this.gyroscopeSamples -= 1;
        }
        var totalAngleX = this.settings.gyroscopeMaxAngleX - this.settings.gyroscopeMinAngleX;
        var totalAngleY = this.settings.gyroscopeMaxAngleY - this.settings.gyroscopeMinAngleY;
        var degreesPerPixelX = totalAngleX / this.width;
        var degreesPerPixelY = totalAngleY / this.height;
        var angleX = event.gamma - (this.settings.gyroscopeMinAngleX + this.gammazero);
        var angleY = event.beta - (this.settings.gyroscopeMinAngleY + this.betazero);
        var posX = angleX / degreesPerPixelX;
        var posY = angleY / degreesPerPixelY;
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = {
            clientX: posX + this.left,
            clientY: posY + this.top
        };
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseEnter = function onMouseEnter() {
        this.updateElementPosition();
        this.element.style.willChange = "transform";
        this.setTransition();
    };
    VanillaTilt.prototype.onMouseMove = function onMouseMove(event) {
        if (this.updateCall !== null) cancelAnimationFrame(this.updateCall);
        this.event = event;
        this.updateCall = requestAnimationFrame(this.updateBind);
    };
    VanillaTilt.prototype.onMouseLeave = function onMouseLeave() {
        this.setTransition();
        if (this.settings.reset) requestAnimationFrame(this.resetBind);
    };
    VanillaTilt.prototype.reset = function reset() {
        this.onMouseEnter();
        if (this.fullPageListening) this.event = {
            clientX: (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.clientWidth,
            clientY: (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.clientHeight
        };
        else this.event = {
            clientX: this.left + (this.settings.startX + this.settings.max) / (2 * this.settings.max) * this.width,
            clientY: this.top + (this.settings.startY + this.settings.max) / (2 * this.settings.max) * this.height
        };
        var backupScale = this.settings.scale;
        this.settings.scale = 1;
        this.update();
        this.settings.scale = backupScale;
        this.resetGlare();
    };
    VanillaTilt.prototype.resetGlare = function resetGlare() {
        if (this.glare) {
            this.glareElement.style.transform = "rotate(180deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "0";
        }
    };
    VanillaTilt.prototype.getValues = function getValues() {
        var x = void 0, y = void 0;
        if (this.fullPageListening) {
            x = this.event.clientX / this.clientWidth;
            y = this.event.clientY / this.clientHeight;
        } else {
            x = (this.event.clientX - this.left) / this.width;
            y = (this.event.clientY - this.top) / this.height;
        }
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);
        var tiltX = (this.reverse * (this.settings.max - x * this.settings.max * 2)).toFixed(2);
        var tiltY = (this.reverse * (y * this.settings.max * 2 - this.settings.max)).toFixed(2);
        var angle = Math.atan2(this.event.clientX - (this.left + this.width / 2), -(this.event.clientY - (this.top + this.height / 2))) * (180 / Math.PI);
        return {
            tiltX: tiltX,
            tiltY: tiltY,
            percentageX: x * 100,
            percentageY: y * 100,
            angle: angle
        };
    };
    VanillaTilt.prototype.updateElementPosition = function updateElementPosition() {
        var rect = this.element.getBoundingClientRect();
        this.width = this.element.offsetWidth;
        this.height = this.element.offsetHeight;
        this.left = rect.left;
        this.top = rect.top;
    };
    VanillaTilt.prototype.update = function update() {
        var values = this.getValues();
        this.element.style.transform = "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")";
        if (this.glare) {
            this.glareElement.style.transform = "rotate(" + values.angle + "deg) translate(-50%, -50%)";
            this.glareElement.style.opacity = "" + values.percentageY * this.settings["max-glare"] / 100;
        }
        this.element.dispatchEvent(new CustomEvent("tiltChange", {
            "detail": values
        }));
        this.updateCall = null;
    };
    /**
   * Appends the glare element (if glarePrerender equals false)
   * and sets the default style
   */ VanillaTilt.prototype.prepareGlare = function prepareGlare() {
        // If option pre-render is enabled we assume all html/css is present for an optimal glare effect.
        if (!this.glarePrerender) {
            // Create glare element
            var jsTiltGlare = document.createElement("div");
            jsTiltGlare.classList.add("js-tilt-glare");
            var jsTiltGlareInner = document.createElement("div");
            jsTiltGlareInner.classList.add("js-tilt-glare-inner");
            jsTiltGlare.appendChild(jsTiltGlareInner);
            this.element.appendChild(jsTiltGlare);
        }
        this.glareElementWrapper = this.element.querySelector(".js-tilt-glare");
        this.glareElement = this.element.querySelector(".js-tilt-glare-inner");
        if (this.glarePrerender) return;
        Object.assign(this.glareElementWrapper.style, {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "overflow": "hidden",
            "pointer-events": "none",
            "border-radius": "inherit"
        });
        Object.assign(this.glareElement.style, {
            "position": "absolute",
            "top": "50%",
            "left": "50%",
            "pointer-events": "none",
            "background-image": "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            "transform": "rotate(180deg) translate(-50%, -50%)",
            "transform-origin": "0% 0%",
            "opacity": "0"
        });
        this.updateGlareSize();
    };
    VanillaTilt.prototype.updateGlareSize = function updateGlareSize() {
        if (this.glare) {
            var glareSize = (this.element.offsetWidth > this.element.offsetHeight ? this.element.offsetWidth : this.element.offsetHeight) * 2;
            Object.assign(this.glareElement.style, {
                "width": glareSize + "px",
                "height": glareSize + "px"
            });
        }
    };
    VanillaTilt.prototype.updateClientSize = function updateClientSize() {
        this.clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    };
    VanillaTilt.prototype.onWindowResize = function onWindowResize() {
        this.updateGlareSize();
        this.updateClientSize();
    };
    VanillaTilt.prototype.setTransition = function setTransition() {
        var _this = this;
        clearTimeout(this.transitionTimeout);
        this.element.style.transition = this.settings.speed + "ms " + this.settings.easing;
        if (this.glare) this.glareElement.style.transition = "opacity " + this.settings.speed + "ms " + this.settings.easing;
        this.transitionTimeout = setTimeout(function() {
            _this.element.style.transition = "";
            if (_this.glare) _this.glareElement.style.transition = "";
        }, this.settings.speed);
    };
    /**
   * Method return patched settings of instance
   * @param {boolean} settings.reverse - reverse the tilt direction
   * @param {number} settings.max - max tilt rotation (degrees)
   * @param {startX} settings.startX - the starting tilt on the X axis, in degrees. Default: 0
   * @param {startY} settings.startY - the starting tilt on the Y axis, in degrees. Default: 0
   * @param {number} settings.perspective - Transform perspective, the lower the more extreme the tilt gets
   * @param {string} settings.easing - Easing on enter/exit
   * @param {number} settings.scale - 2 = 200%, 1.5 = 150%, etc..
   * @param {number} settings.speed - Speed of the enter/exit transition
   * @param {boolean} settings.transition - Set a transition on enter/exit
   * @param {string|null} settings.axis - What axis should be enabled. Can be "x" or "y"
   * @param {boolean} settings.glare - if it should have a "glare" effect
   * @param {number} settings.max-glare - the maximum "glare" opacity (1 = 100%, 0.5 = 50%)
   * @param {boolean} settings.glare-prerender - false = VanillaTilt creates the glare elements for you, otherwise
   * @param {boolean} settings.full-page-listening - If true, parallax effect will listen to mouse move events on the whole document, not only the selected element
   * @param {string|object} settings.mouse-event-element - String selector or link to HTML-element what will be listen mouse events
   * @param {boolean} settings.reset - false = If the tilt effect has to be reset on exit
   * @param {boolean} settings.reset-to-start - true = On reset event (mouse leave) will return to initial start angle (if startX or startY is set)
   * @param {gyroscope} settings.gyroscope - Enable tilting by deviceorientation events
   * @param {gyroscopeSensitivity} settings.gyroscopeSensitivity - Between 0 and 1 - The angle at which max tilt position is reached. 1 = 90deg, 0.5 = 45deg, etc..
   * @param {gyroscopeSamples} settings.gyroscopeSamples - How many gyroscope moves to decide the starting position.
   */ VanillaTilt.prototype.extendSettings = function extendSettings(settings) {
        var defaultSettings = {
            reverse: false,
            max: 15,
            startX: 0,
            startY: 0,
            perspective: 1000,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            scale: 1,
            speed: 300,
            transition: true,
            axis: null,
            glare: false,
            "max-glare": 1,
            "glare-prerender": false,
            "full-page-listening": false,
            "mouse-event-element": null,
            reset: true,
            "reset-to-start": true,
            gyroscope: true,
            gyroscopeMinAngleX: -45,
            gyroscopeMaxAngleX: 45,
            gyroscopeMinAngleY: -45,
            gyroscopeMaxAngleY: 45,
            gyroscopeSamples: 10
        };
        var newSettings = {};
        for(var property in defaultSettings){
            if (property in settings) newSettings[property] = settings[property];
            else if (this.element.hasAttribute("data-tilt-" + property)) {
                var attribute = this.element.getAttribute("data-tilt-" + property);
                try {
                    newSettings[property] = JSON.parse(attribute);
                } catch (e) {
                    newSettings[property] = attribute;
                }
            } else newSettings[property] = defaultSettings[property];
        }
        return newSettings;
    };
    VanillaTilt.init = function init(elements, settings) {
        if (elements instanceof Node) elements = [
            elements
        ];
        if (elements instanceof NodeList) elements = [].slice.call(elements);
        if (!(elements instanceof Array)) return;
        elements.forEach(function(element) {
            if (!("vanillaTilt" in element)) element.vanillaTilt = new VanillaTilt(element, settings);
        });
    };
    return VanillaTilt;
}();
if (typeof document !== "undefined") {
    /* expose the class to window */ window.VanillaTilt = $b5f6d4efc654cf78$var$VanillaTilt;
    /**
   * Auto load
   */ $b5f6d4efc654cf78$var$VanillaTilt.init(document.querySelectorAll("[data-tilt]"));
}
$b5f6d4efc654cf78$exports = $b5f6d4efc654cf78$var$VanillaTilt;


function $b8855ed206bb3c2e$export$2e2bcd8739ae039() {
    const elements = document.querySelectorAll(".js-tilt");
    (0, (/*@__PURE__*/$parcel$interopDefault($b5f6d4efc654cf78$exports))).init(elements);
}


const $d859da13df4a30ff$export$9c21a3269931e1e6 = {
    easing: "cubic-bezier(0.5, 0, 0, 1)",
    distance: "30px",
    duration: 1000,
    desktop: true,
    mobile: true
};
const $d859da13df4a30ff$export$adcf75ad64a03007 = [
    {
        element: ".section-title",
        animation: {
            delay: 300,
            distance: "0px",
            origin: "bottom"
        }
    },
    {
        element: ".home-title",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".home-cta",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".home__image",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__image",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".about-wrapper__info",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".why-me-wrapper__icons",
        animation: {
            delay: 600,
            origin: "bottom"
        }
    },
    {
        element: ".why-me-wrapper__info",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__text",
        animation: {
            delay: 500,
            origin: window.innerWidth > 768 ? "left" : "bottom"
        }
    },
    {
        element: ".project-wrapper__image",
        animation: {
            delay: 1000,
            origin: window.innerWidth > 768 ? "right" : "bottom"
        }
    },
    {
        element: ".contact-wrapper",
        animation: {
            delay: 800,
            origin: "bottom"
        }
    }
];


function $d17ec4acc561ff09$export$2e2bcd8739ae039() {
    const element = document.querySelector(".nav-menu__mobile");
    if (element.classList.contains("hide")) element.classList.remove("hide");
    else element.classList.add("hide");
}


function $549936df23f95449$export$2e2bcd8739ae039() {
    const prints = document.querySelector(".prints");
    if (prints.classList.contains("prints-reverse")) prints.classList.remove("prints-reverse");
    else prints.classList.add("prints-reverse");
}


// Импортируем массив проектов
var $9a62a68d6b66cb35$exports = {};
$9a62a68d6b66cb35$exports = new URL("atlon.5fa21094.png", import.meta.url).toString();


var $261c4f052eb88761$exports = {};
$261c4f052eb88761$exports = new URL("sms-service.72f930d1.png", import.meta.url).toString();


var $c6bae64fc32e5559$exports = {};
$c6bae64fc32e5559$exports = new URL("any-sites.8cde7276.png", import.meta.url).toString();


var $059c28e4c52c5376$exports = {};
$059c28e4c52c5376$exports = new URL("stockie.16cdb1ac.jpg", import.meta.url).toString();


var $4607a59b6c87dd1a$exports = {};
$4607a59b6c87dd1a$exports = new URL("open.41d6bb34.png", import.meta.url).toString();


var $765c4918b6d7689d$exports = {};
$765c4918b6d7689d$exports = new URL("yaft.e4b59bdd.png", import.meta.url).toString();


var $6d7fe116c9009973$exports = {};
$6d7fe116c9009973$exports = new URL("carbon.0cb44833.jpg", import.meta.url).toString();


var $1ebccba73c3108a4$exports = {};
$1ebccba73c3108a4$exports = new URL("monopoly.ad82aa0b.png", import.meta.url).toString();


const $9337a2b725b875ba$export$cb1f63fb7a693f5e = [
    {
        title: {
            ru: "KASCRM",
            en: "KASCRM"
        },
        description: {
            ru: `KASCRM \u{2014} \u{43A}\u{43E}\u{43C}\u{43F}\u{43B}\u{435}\u{43A}\u{441}\u{43D}\u{430}\u{44F} \u{44D}\u{43A}\u{43E}\u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{430} (CRM, ERP, BI), \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{438}\u{440}\u{443}\u{44E}\u{449}\u{430}\u{44F} \u{431}\u{438}\u{437}\u{43D}\u{435}\u{441}-\u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{44B} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{438}.
      <br />\u{41C}\u{43E}\u{439} \u{432}\u{43A}\u{43B}\u{430}\u{434} \u{438} \u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{432}\u{44B}\u{435} \u{437}\u{430}\u{434}\u{430}\u{447}\u{438}:
      <br />\u{41F}\u{435}\u{440}\u{435}\u{432}\u{435}\u{43B} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442} \u{441} Inertia.js \u{43D}\u{430} Nuxt 3 (\u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{446}\u{435}\u{43D}\u{43D}\u{43E}\u{435} PWA \u{441} \u{43F}\u{43E}\u{434}\u{434}\u{435}\u{440}\u{436}\u{43A}\u{43E}\u{439} Push).
      <br />\u{421}\u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B} \u{438} \u{432}\u{43D}\u{435}\u{434}\u{440}\u{438}\u{43B} \u{433}\u{438}\u{431}\u{43A}\u{443}\u{44E} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443} \u{440}\u{430}\u{437}\u{440}\u{435}\u{448}\u{435}\u{43D}\u{438}\u{439} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} \u{440}\u{43E}\u{43B}\u{435}\u{439} \u{438} \u{43E}\u{442}\u{434}\u{435}\u{43B}\u{43E}\u{432}.
      <br />\u{418}\u{43D}\u{442}\u{435}\u{433}\u{440}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{443} \u{441} WebSockets \u{438} API, \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{43B} \u{432} \u{440}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{435} \u{432}\u{43D}\u{443}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{435}\u{433}\u{43E} \u{43A}\u{43E}\u{440}\u{43F}\u{43E}\u{440}\u{430}\u{442}\u{438}\u{432}\u{43D}\u{43E}\u{433}\u{43E} \u{447}\u{430}\u{442}\u{430} \u{438} \u{435}\u{433}\u{43E} \u{432}\u{43D}\u{435}\u{434}\u{440}\u{435}\u{43D}\u{438}\u{438} \u{432} CRM.
      <br />\u{421}\u{43E}\u{437}\u{434}\u{430}\u{43B} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{443} \u{431}\u{44B}\u{441}\u{442}\u{440}\u{44B}\u{445} \u{43F}\u{430}\u{43D}\u{435}\u{43B}\u{435}\u{439}, \u{442}\u{443}\u{440}\u{43E}\u{432}(\u{433}\u{430}\u{439}\u{434}\u{43E}\u{432}) \u{438} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43B} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{438} \u{432}\u{438}\u{434}\u{435}\u{43E}\u{433}\u{430}\u{439}\u{434}\u{43E}\u{432} \u{43F}\u{43E} \u{441}\u{438}\u{441}\u{442}\u{435}\u{43C}\u{435}.
      <br />\u{41D}\u{430}\u{441}\u{442}\u{440}\u{43E}\u{438}\u{43B} \u{438}\u{43D}\u{442}\u{435}\u{433}\u{440}\u{430}\u{446}\u{438}\u{438} \u{447}\u{435}\u{440}\u{435}\u{437} n8n \u{438} Telegram-\u{431}\u{43E}\u{442}\u{43E}\u{432} \u{434}\u{43B}\u{44F} \u{430}\u{432}\u{442}\u{43E}\u{43C}\u{430}\u{442}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{432}\u{43D}\u{443}\u{442}\u{440}\u{435}\u{43D}\u{43D}\u{438}\u{445} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{441}\u{441}\u{43E}\u{432} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{438}.`,
            en: `KASCRM is a comprehensive ecosystem (CRM, ERP, BI) that automates company business processes.
      <br />My contribution and key tasks:
      <br />Migrated the project from Inertia.js to Nuxt 3 (full PWA with Push support).
      <br />Designed and implemented a flexible role- and department-based permission system.
      <br />Integrated WebSockets and APIs, participated in the development of an internal corporate chat and its integration into the CRM.
      <br />Created a system of quick panels, tours (guides), and automated the creation of video guides for the system.
      <br />Configured integrations via n8n and Telegram bots to automate internal company processes.`
        },
        image: new URL($9a62a68d6b66cb35$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "goToService",
                url: "https://kascrm.ru",
                className: "cta-btn--home"
            }
        ]
    },
    {
        title: {
            ru: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u043B\u044F \u043F\u0440\u0438\u0435\u043C\u0430 \u0441\u043C\u0441",
            en: "SMS Reception Service"
        },
        description: {
            ru: `SMS-Service - \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{441}\u{43E}\u{431}\u{43E}\u{439} \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{43E}\u{43D}\u{430}\u{433}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{43D}\u{443}\u{44E} \u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{443}, \u{43E}\u{431}\u{441}\u{43B}\u{443}\u{436}\u{438}\u{432}\u{430}\u{44E}\u{449}\u{443}\u{44E} \u{442}\u{44B}\u{441}\u{44F}\u{447}\u{438} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{435}\u{436}\u{435}\u{434}\u{43D}\u{435}\u{432}\u{43D}\u{43E}. \u{420}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{441} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} \u{442}\u{435}\u{445}\u{43D}\u{43E}\u{43B}\u{43E}\u{433}\u{438}\u{439} Nuxt 2, Vue \u{438} Vuex.<br />
      \u{41C}\u{43E}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{430} \u{437}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{43B}\u{430}\u{441}\u{44C} \u{432} \u{43B}\u{43E}\u{43A}\u{430}\u{43B}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{44F} \u{441} Nuxt-i18n, \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439} \u{438}\u{437} \u{440}\u{430}\u{437}\u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{445} \u{440}\u{435}\u{433}\u{438}\u{43E}\u{43D}\u{43E}\u{432}. \u{41A}\u{440}\u{43E}\u{43C}\u{435} \u{442}\u{43E}\u{433}\u{43E}, \u{44F} \u{437}\u{430}\u{43D}\u{438}\u{43C}\u{430}\u{43B}\u{441}\u{44F} \u{43C}\u{430}\u{43D}\u{438}\u{43F}\u{443}\u{43B}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} \u{434}\u{430}\u{43D}\u{43D}\u{44B}\u{43C}\u{438}, \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44F} \u{440}\u{430}\u{431}\u{43E}\u{442}\u{443} \u{441} \u{434}\u{430}\u{442}\u{430}\u{43C}\u{438} \u{43F}\u{440}\u{438} \u{43F}\u{43E}\u{43C}\u{43E}\u{449}\u{438} \u{431}\u{438}\u{431}\u{43B}\u{438}\u{43E}\u{442}\u{435}\u{43A}\u{438} moment.js, \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{435}\u{43C} \u{434}\u{440}\u{443}\u{433}\u{438}\u{445} \u{437}\u{430}\u{434}\u{430}\u{447} \u{43F}\u{43E} \u{43E}\u{43F}\u{442}\u{438}\u{43C}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{438} \u{43B}\u{43E}\u{433}\u{438}\u{43A}\u{435} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{430}\u{439}\u{442}\u{430}.`,
            en: `SMS-Service is a high-load platform serving thousands of users daily. Developed using Nuxt 2, Vue, and Vuex.<br />
      My work involved localizing the application with Nuxt-i18n for users from various regions. Additionally, I handled data manipulation, including working with dates using the moment.js library, as well as performing other optimization and site logic tasks.`
        },
        image: new URL($261c4f052eb88761$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "goToService",
                url: "https://rent.sms-activation-service.com/",
                className: "cta-btn--home"
            }
        ]
    },
    {
        title: {
            ru: "\u0410\u0442\u043B\u043E\u043D \u0424\u041C",
            en: "Atlon FM"
        },
        description: {
            ru: `\u{420}\u{443}\u{43A}\u{43E}\u{432}\u{43E}\u{434}\u{441}\u{442}\u{432}\u{43E} \u{440}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{43E}\u{439} \u{432}\u{435}\u{431}-\u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{432} \u{43A}\u{43E}\u{43C}\u{43F}\u{430}\u{43D}\u{438}\u{438} \u{410}\u{442}\u{43B}\u{43E}\u{43D} \u{424}\u{41C}.
      <br />\u{41C}\u{43E}\u{439} \u{432}\u{43A}\u{43B}\u{430}\u{434} \u{438} \u{43A}\u{43B}\u{44E}\u{447}\u{435}\u{432}\u{44B}\u{435} \u{437}\u{430}\u{434}\u{430}\u{447}\u{438}:
      <br />\u{423}\u{447}\u{430}\u{441}\u{442}\u{438}\u{435} \u{432} \u{43E}\u{431}\u{441}\u{443}\u{436}\u{434}\u{435}\u{43D}\u{438}\u{44F}\u{445} \u{43F}\u{43E} \u{440}\u{430}\u{437}\u{432}\u{438}\u{442}\u{438}\u{44E} \u{438}\u{43D}\u{444}\u{440}\u{430}\u{441}\u{442}\u{440}\u{443}\u{43A}\u{442}\u{443}\u{440}\u{44B}.
      <br />\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435} \u{430}\u{440}\u{445}\u{438}\u{442}\u{435}\u{43A}\u{442}\u{443}\u{440}\u{44B} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{43E}\u{432} \u{43D}\u{430} Vue/KirbyCMS/Inertia.
      <br />\u{41F}\u{43E}\u{441}\u{442}\u{430}\u{43D}\u{43E}\u{432}\u{43A}\u{430} \u{442}\u{435}\u{445}\u{43D}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{445} \u{437}\u{430}\u{434}\u{430}\u{447}, \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{43E}\u{43B}\u{44C} \u{441}\u{440}\u{43E}\u{43A}\u{438} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D}\u{438}\u{44F} \u{438} \u{43E}\u{431}\u{44A}\u{44F}\u{441}\u{43D}\u{435}\u{43D}\u{438}\u{435} \u{431}\u{438}\u{437}\u{43D}\u{435}\u{441} \u{43F}\u{440}\u{43E}\u{446}\u{435}\u{435}\u{441}\u{441}\u{43E}\u{432}.
      <br />\u{41F}\u{440}\u{43E}\u{432}\u{435}\u{434}\u{435}\u{43D}\u{438}\u{435} Code Review \u{438} \u{43A}\u{43E}\u{43D}\u{442}\u{440}\u{43E}\u{43B}\u{44C} \u{43A}\u{430}\u{447}\u{435}\u{441}\u{442}\u{432}\u{430} \u{43A}\u{43E}\u{434}\u{430} \u{43C}\u{43B}\u{430}\u{434}\u{448}\u{438}\u{445} \u{441}\u{43F}\u{435}\u{446}\u{438}\u{430}\u{43B}\u{438}\u{441}\u{442}\u{43E}\u{432}.`,
            en: `Leading the development of web projects for Atlon FM company.
      <br />My contribution and key tasks:
      <br />Participation in discussions on infrastructure development.
      <br />Designing project architecture using Vue/KirbyCMS/Inertia.
      <br />Setting technical tasks, monitoring deadlines, and explaining business processes.
      <br />Conducting Code Review and quality control of junior specialists' code.`
        },
        image: new URL($c6bae64fc32e5559$exports).toString(),
        imageClass: "no-shadow",
        links: [
            {
                text: "site1",
                url: "https://deffecto.ru",
                className: "cta-btn--home"
            },
            {
                text: "site2",
                url: "https://spbatlon.ru",
                className: "cta-btn--home"
            },
            {
                text: "site3",
                url: "https://chistotop.ru",
                className: "cta-btn--home"
            }
        ]
    },
    {
        title: {
            ru: "Stockie CRM",
            en: "Stockie CRM"
        },
        description: {
            ru: `Stockie - \u{43F}\u{440}\u{435}\u{434}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{441}\u{43E}\u{431}\u{43E}\u{439} \u{432}\u{44B}\u{441}\u{43E}\u{43A}\u{43E}\u{43D}\u{430}\u{433}\u{440}\u{443}\u{436}\u{435}\u{43D}\u{43D}\u{443}\u{44E} crm \u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{443}, \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{44F}\u{44E}\u{449}\u{443}\u{44E} 100+ \u{441}\u{43A}\u{43B}\u{430}\u{434}\u{43E}\u{432} \u{43F}\u{43E} \u{432}\u{441}\u{435}\u{439} \u{420}\u{43E}\u{441}\u{441}\u{438}\u{438}. \u{420}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{441} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} \u{442}\u{435}\u{445}\u{43D}\u{43E}\u{43B}\u{43E}\u{433}\u{438}\u{439} Java, Vue, Vuex, Docker \u{438} \u{442}.\u{434}.<br />
      \u{41C}\u{43E}\u{44F} \u{440}\u{43E}\u{43B}\u{44C} \u{437}\u{430}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{432} \u{43E}\u{43F}\u{442}\u{438}\u{43C}\u{438}\u{437}\u{430}\u{446}\u{438}\u{438} \u{43A}\u{43E}\u{434}\u{430} \u{438} \u{440}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{438} \u{43B}\u{43E}\u{433}\u{438}\u{43A}\u{438} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{430}\u{439}\u{442}\u{430}.`,
            en: `Stockie is a high-load CRM platform uniting 100+ warehouses across Russia. Developed using Java, Vue, Vuex, Docker, etc.<br />
      My role involved code optimization and developing the website's core logic.`
        },
        image: new URL($059c28e4c52c5376$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "goToService",
                url: "https://stockie.ru",
                className: "cta-btn--home"
            }
        ]
    },
    {
        title: {
            ru: "\u0412\u0435\u0431-\u0441\u0430\u0439\u0442 OpenCoin Project",
            en: "OpenCoin Project Website"
        },
        description: {
            ru: `Open Coin Project - \u{441} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} \u{441}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{433}\u{43E} \u{444}\u{440}\u{435}\u{439}\u{43C}\u{432}\u{43E}\u{440}\u{43A}\u{430}. \u{42F} \u{443}\u{447}\u{430}\u{441}\u{442}\u{432}\u{43E}\u{432}\u{430}\u{43B} \u{432} \u{440}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{43A}\u{435} \u{44D}\u{442}\u{43E}\u{433}\u{43E} \u{441}\u{430}\u{439}\u{442}\u{430}, \u{432}\u{43D}\u{435}\u{434}\u{440}\u{44F}\u{44F} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{438} \u{43E}\u{431}\u{435}\u{441}\u{43F}\u{435}\u{447}\u{438}\u{432}\u{430}\u{44F} \u{443}\u{434}\u{43E}\u{431}\u{441}\u{442}\u{432}\u{43E} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{434}\u{43B}\u{44F} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{435}\u{439}.<br />
      \u{41C}\u{44B} \u{441}\u{442}\u{440}\u{435}\u{43C}\u{438}\u{43B}\u{438}\u{441}\u{44C} \u{43A} \u{43B}\u{435}\u{433}\u{43A}\u{43E}\u{43C}\u{443} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{443}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{443}\u{434}\u{43E}\u{432}\u{43B}\u{435}\u{442}\u{432}\u{43E}\u{440}\u{44F}\u{43B} \u{431}\u{44B} \u{43F}\u{43E}\u{442}\u{440}\u{435}\u{431}\u{43D}\u{43E}\u{441}\u{442}\u{438} \u{446}\u{435}\u{43B}\u{435}\u{432}\u{43E}\u{439} \u{430}\u{443}\u{434}\u{438}\u{442}\u{43E}\u{440}\u{438}\u{438}. \u{412}\u{435}\u{431}-\u{441}\u{430}\u{439}\u{442} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{442} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E} \u{43E} \u{441}\u{430}\u{43C}\u{43E}\u{43C} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{435} \u{438} \u{435}\u{433}\u{43E} \u{43A}\u{43E}\u{43D}\u{446}\u{435}\u{43F}\u{446}\u{438}\u{438}, \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} \u{43E} \u{434}\u{440}\u{443}\u{433}\u{438}\u{445} \u{43F}\u{440}\u{43E}\u{434}\u{443}\u{43A}\u{442}\u{430}\u{445}, \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{430}\u{433}\u{430}\u{435}\u{43C}\u{44B}\u{445} \u{440}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{447}\u{438}\u{43A}\u{430}\u{43C}\u{438} \u{438} \u{434}\u{43E}\u{440}\u{43E}\u{436}\u{43D}\u{443}\u{44E} \u{43A}\u{430}\u{440}\u{442}\u{443} \u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}\u{430}.`,
            en: `Open Coin Project - using a modern framework. I participated in the development of this site, implementing functionality and ensuring usability for users.<br />
      We aimed for a lightweight interface that would satisfy the target audience's needs. The website provides information about the project itself, its concept, other products offered by the developers, and the project roadmap.`
        },
        image: new URL($4607a59b6c87dd1a$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "goToService",
                url: "https://openproject.app",
                className: "cta-btn--home"
            }
        ]
    },
    {
        title: {
            ru: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u043B\u044F \u0442\u0443\u0440\u0438\u0441\u0442\u043E\u0432 YAFT",
            en: "YAFT Service for Tourists"
        },
        description: {
            ru: `\u{41C}\u{443}\u{43B}\u{44C}\u{442}\u{438}\u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{435}\u{43D}\u{43D}\u{44B}\u{439} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441} \u{43D}\u{430} Vue 3, Vuex \u{441} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} PW\u{410}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{439} \u{43F}\u{440}\u{435}\u{434}\u{43B}\u{430}\u{433}\u{430}\u{435}\u{442} \u{432}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43F}\u{43B}\u{430}\u{43D}\u{438}\u{440}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{44F} \u{442}\u{443}\u{440}\u{438}\u{441}\u{442}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{438}\u{445} \u{43F}\u{43E}\u{445}\u{43E}\u{434}\u{43E}\u{432} \u{43F}\u{43E} \u{420}\u{43E}\u{441}\u{441}\u{438}\u{438}.<br />
      \u{41C}\u{44B} \u{43F}\u{43E}\u{43C}\u{43E}\u{433}\u{430}\u{435}\u{43C} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}\u{43C} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{43C}\u{430}\u{440}\u{448}\u{440}\u{443}\u{442}, \u{43F}\u{43E}\u{434}\u{43E}\u{431}\u{440}\u{430}\u{442}\u{44C} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{43E}\u{434}\u{438}\u{43C}\u{43E}\u{435} \u{441}\u{43D}\u{430}\u{440}\u{44F}\u{436}\u{435}\u{43D}\u{438}\u{435} \u{441}\u{43E}\u{433}\u{43B}\u{430}\u{441}\u{43D}\u{43E} \u{43F}\u{43E}\u{433}\u{43E}\u{434}\u{435} \u{438} \u{442}\u{438}\u{43F}\u{44B} \u{442}\u{443}\u{440}\u{438}\u{437}\u{43C}\u{430} \u{438} \u{43F}\u{440}\u{435}\u{434}\u{43E}\u{441}\u{442}\u{430}\u{432}\u{43B}\u{44F}\u{435}\u{43C} \u{438}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{438}\u{44E} \u{43E} \u{434}\u{43E}\u{441}\u{442}\u{43E}\u{43F}\u{440}\u{438}\u{43C}\u{435}\u{447}\u{430}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{44F}\u{445} \u{438} \u{43A}\u{443}\u{43B}\u{44C}\u{442}\u{443}\u{440}\u{43D}\u{44B}\u{445} \u{441}\u{43E}\u{431}\u{44B}\u{442}\u{438}\u{44F}\u{445} \u{432} \u{432}\u{44B}\u{431}\u{440}\u{430}\u{43D}\u{43D}\u{43E}\u{43C} \u{440}\u{435}\u{433}\u{438}\u{43E}\u{43D}\u{435}.
      <br />\u{42D}\u{442}\u{43E}\u{442} \u{43C}\u{43E}\u{439} pet-\u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}.`,
            en: `A multiplatform service using Vue 3, Vuex, and PWA that offers the ability to plan hiking trips across Russia.<br />
      We help users choose a route, select the necessary equipment according to the weather and type of tourism, and provide information about attractions and cultural events in the selected region.
      <br />This is my pet project.`
        },
        image: new URL($765c4918b6d7689d$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "demo",
                url: "https://yaft.netlify.app/",
                className: "cta-btn--home"
            },
            {
                text: "github",
                url: "https://github.com/dazzv/yaft",
                className: "text-color-main"
            }
        ]
    },
    {
        title: {
            ru: "Carbon Hairstyle",
            en: "Carbon Hairstyle"
        },
        description: {
            ru: `"Carbon Hairstyle" - \u{44D}\u{442}\u{43E} \u{438}\u{43D}\u{43D}\u{43E}\u{432}\u{430}\u{446}\u{438}\u{43E}\u{43D}\u{43D}\u{44B}\u{439} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441}, \u{43E}\u{431}\u{44A}\u{435}\u{434}\u{438}\u{43D}\u{44F}\u{44E}\u{449}\u{438}\u{439} \u{432} \u{441}\u{435}\u{431}\u{435} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B} \u{441}\u{43E}\u{446}\u{438}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{439} \u{441}\u{435}\u{442}\u{438} \u{441} \u{432}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44F}\u{43C}\u{438} \u{43E}\u{43D}\u{43B}\u{430}\u{439}\u{43D}-\u{43F}\u{43B}\u{430}\u{442}\u{444}\u{43E}\u{440}\u{43C}\u{44B} \u{434}\u{43B}\u{44F} \u{443}\u{445}\u{43E}\u{434}\u{430} \u{437}\u{430} \u{432}\u{43E}\u{43B}\u{43E}\u{441}\u{430}\u{43C}\u{438} \u{438} \u{441}\u{43E}\u{437}\u{434}\u{430}\u{43D}\u{438}\u{44F} \u{441}\u{442}\u{438}\u{43B}\u{44C}\u{43D}\u{44B}\u{445} \u{43F}\u{440}\u{438}\u{447}\u{435}\u{441}\u{43E}\u{43A}. \u{420}\u{430}\u{437}\u{440}\u{430}\u{431}\u{43E}\u{442}\u{430}\u{43D}\u{43D}\u{44B}\u{439} \u{43D}\u{430} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{435} Nuxt 3 (\u{441} \u{438}\u{441}\u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{43D}\u{438}\u{435}\u{43C} SEO, SSR \u{438} Auth, i18n), \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} TypeScript, Vue 3, Tailwind CSS \u{438} Vuex/Pinia.<br />
      \u{41D}\u{430}\u{448} \u{441}\u{435}\u{440}\u{432}\u{438}\u{441} \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{435}\u{442} \u{432} \u{441}\u{435}\u{431}\u{44F} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{438}\u{43E}\u{43D}\u{430}\u{43B} \u{43F}\u{443}\u{431}\u{43B}\u{438}\u{43A}\u{430}\u{446}\u{438}\u{439}, \u{43A}\u{43E}\u{43C}\u{43C}\u{435}\u{43D}\u{442}\u{430}\u{440}\u{438}\u{435}\u{432}, \u{43B}\u{438}\u{447}\u{43D}\u{44B}\u{445} \u{43A}\u{430}\u{431}\u{438}\u{43D}\u{435}\u{442}\u{43E}\u{432} \u{438} \u{442}.\u{434}., \u{43E}\u{431}\u{435}\u{441}\u{43F}\u{435}\u{447}\u{438}\u{432}\u{430}\u{44F} \u{432}\u{43E}\u{437}\u{43C}\u{43E}\u{436}\u{43D}\u{43E}\u{441}\u{442}\u{44C} \u{43E}\u{431}\u{449}\u{435}\u{43D}\u{438}\u{44F}, \u{43E}\u{431}\u{43C}\u{435}\u{43D}\u{430} \u{43E}\u{43F}\u{44B}\u{442}\u{430} \u{438} \u{432}\u{434}\u{43E}\u{445}\u{43D}\u{43E}\u{432}\u{43B}\u{435}\u{43D}\u{438}\u{435}\u{43C} \u{43C}\u{435}\u{436}\u{434}\u{443} \u{43F}\u{43E}\u{43B}\u{44C}\u{437}\u{43E}\u{432}\u{430}\u{442}\u{435}\u{43B}\u{44F}\u{43C}\u{438}. \u{42D}\u{442}\u{43E}\u{442} \u{43C}\u{43E}\u{439} \u{432}\u{442}\u{43E}\u{440}\u{43E}\u{439} pet-\u{43F}\u{440}\u{43E}\u{435}\u{43A}\u{442}, \u{432} \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{43C} \u{44F} \u{432}\u{43A}\u{43B}\u{430}\u{434}\u{44B}\u{432}\u{430}\u{44E} \u{441}\u{432}\u{43E}\u{44E} \u{441}\u{442}\u{440}\u{430}\u{441}\u{442}\u{44C} .`,
            en: `"Carbon Hairstyle" is an innovative service combining social network functionality with online platform capabilities for hair care and styling. Developed with Nuxt 3 (featuring SEO, SSR, Auth, and i18n), TypeScript, Vue 3, Tailwind CSS, and Vuex/Pinia.<br />
      Our service includes publications, comments, personal accounts, etc., enabling communication, experience sharing, and inspiration among users. This is my second pet project, where I invest my passion.`
        },
        image: new URL($6d7fe116c9009973$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "demo",
                url: "https://carbonh.netlify.app/",
                className: "cta-btn--home"
            },
            {
                text: "github",
                url: "https://github.com/dazzv/carbon",
                className: "text-color-main"
            }
        ]
    },
    {
        title: {
            ru: "\u0418\u0433\u0440\u0430 \u041C\u043E\u043D\u043E\u043F\u043E\u043B\u0438\u044F",
            en: "Monopoly Game"
        },
        description: {
            ru: `\u{41F}\u{440}\u{43E}\u{435}\u{43A}\u{442} "\u{41C}\u{43E}\u{43D}\u{43E}\u{43F}\u{43E}\u{43B}\u{438}\u{44F}" \u{43D}\u{430} Vue 3 \u{438} Vuex - \u{44D}\u{442}\u{43E} \u{432}\u{435}\u{431}-\u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{435}, \u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{43E}\u{435} \u{43F}\u{43E}\u{43B}\u{43D}\u{43E}\u{441}\u{442}\u{44C}\u{44E} \u{432}\u{43E}\u{43F}\u{43B}\u{43E}\u{449}\u{430}\u{435}\u{442} \u{43A}\u{43B}\u{430}\u{441}\u{441}\u{438}\u{447}\u{435}\u{441}\u{43A}\u{443}\u{44E} \u{43D}\u{430}\u{441}\u{442}\u{43E}\u{43B}\u{44C}\u{43D}\u{443}\u{44E} \u{438}\u{433}\u{440}\u{443} \u{441} \u{43D}\u{435}\u{43A}\u{43E}\u{442}\u{43E}\u{440}\u{44B}\u{43C}\u{438} \u{443}\u{43B}\u{443}\u{447}\u{448}\u{435}\u{43D}\u{438}\u{44F}\u{43C}\u{438}.
      <br />\u{412} \u{43F}\u{440}\u{438}\u{43B}\u{43E}\u{436}\u{435}\u{43D}\u{438}\u{438} \u{438}\u{433}\u{440}\u{43E}\u{43A}\u{438} \u{43C}\u{43E}\u{433}\u{443}\u{442} \u{431}\u{440}\u{43E}\u{441}\u{430}\u{442}\u{44C} \u{43A}\u{443}\u{431}\u{438}\u{43A} \u{434}\u{43B}\u{44F} \u{445}\u{43E}\u{434}\u{430}, \u{43F}\u{43E}\u{43A}\u{443}\u{43F}\u{430}\u{442}\u{44C} \u{438} \u{43F}\u{440}\u{43E}\u{434}\u{430}\u{432}\u{430}\u{442}\u{44C} \u{43D}\u{435}\u{434}\u{432}\u{438}\u{436}\u{438}\u{43C}\u{43E}\u{441}\u{442}\u{44C}, \u{430} \u{442}\u{430}\u{43A}\u{436}\u{435} \u{443}\u{43F}\u{440}\u{430}\u{432}\u{43B}\u{44F}\u{442}\u{44C} \u{441}\u{432}\u{43E}\u{438}\u{43C}\u{438} \u{444}\u{438}\u{43D}\u{430}\u{43D}\u{441}\u{430}\u{43C}\u{438}. \u{414}\u{438}\u{437}\u{430}\u{439}\u{43D} \u{432}\u{44B}\u{43F}\u{43E}\u{43B}\u{43D}\u{435}\u{43D} \u{432} \u{441}\u{43E}\u{432}\u{440}\u{435}\u{43C}\u{435}\u{43D}\u{43D}\u{43E}\u{43C} \u{441}\u{442}\u{438}\u{43B}\u{435} \u{441} \u{43F}\u{440}\u{43E}\u{441}\u{442}\u{43E}\u{43C} \u{438}\u{43D}\u{442}\u{435}\u{440}\u{444}\u{435}\u{439}\u{441}\u{43E}\u{43C}.`,
            en: `The "Monopoly" project on Vue 3 and Vuex is a web application that fully recreates the classic board game with several enhancements.
      <br />In the app, players can roll dice to move, buy and sell real estate, and manage their finances. The design is modern with a simple interface.`
        },
        image: new URL($1ebccba73c3108a4$exports).toString(),
        imageClass: "",
        links: [
            {
                text: "demo",
                url: "https://dazzv-monopoly.netlify.app/",
                className: "cta-btn--home"
            },
            {
                text: "github",
                url: "https://github.com/dazzv/monopoly-game",
                className: "text-color-main"
            }
        ]
    }
];


const $a85827dfdcfb16a5$export$7540ac15abfd28b6 = {
    ru: {
        links: {
            goToService: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0421\u0435\u0440\u0432\u0438\u0441",
            site1: "\u0421\u0430\u0439\u0442 1",
            site2: "\u0421\u0430\u0439\u0442 2",
            site3: "\u0421\u0430\u0439\u0442 3",
            demo: "\u0414\u0435\u043C\u043E",
            github: "GitHub"
        }
    },
    en: {
        links: {
            goToService: "Go to Service",
            site1: "Site 1",
            site2: "Site 2",
            site3: "Site 3",
            demo: "Demo",
            github: "GitHub"
        }
    }
};


const $4307ff1b793d7d7d$export$b110f9681740cce = "language";
const $4307ff1b793d7d7d$var$DEFAULT_LANGUAGE = "en";
const $4307ff1b793d7d7d$var$SUPPORTED_LANGUAGES = [
    "ru",
    "en"
];
// Определяем язык браузера/системы пользователя (navigator.languages в приоритете,
// т.к. учитывает весь список предпочитаемых языков, а не только основной)
function $4307ff1b793d7d7d$var$detectBrowserLanguage() {
    const browserLanguages = navigator.languages && navigator.languages.length ? navigator.languages : [
        navigator.language || navigator.userLanguage
    ];
    for (const lang of browserLanguages){
        if (!lang) continue;
        const shortLang = lang.slice(0, 2).toLowerCase();
        if ($4307ff1b793d7d7d$var$SUPPORTED_LANGUAGES.includes(shortLang)) return shortLang;
    }
    return $4307ff1b793d7d7d$var$DEFAULT_LANGUAGE;
}
function $4307ff1b793d7d7d$export$64783e31db14f0ba() {
    const stored = localStorage.getItem($4307ff1b793d7d7d$export$b110f9681740cce);
    if (stored && $4307ff1b793d7d7d$var$SUPPORTED_LANGUAGES.includes(stored)) return stored;
    // Первый визит: сохраняем определённый язык, чтобы дальше отдавать его стабильно
    const detected = $4307ff1b793d7d7d$var$detectBrowserLanguage();
    localStorage.setItem($4307ff1b793d7d7d$export$b110f9681740cce, detected);
    return detected;
}


function $1a4136fab1846a2e$export$84595048c9b04d69() {
    const container = document.querySelector("#projects-container");
    if (!container) return;
    const lang = (0, $4307ff1b793d7d7d$export$64783e31db14f0ba)();
    const t = (0, $a85827dfdcfb16a5$export$7540ac15abfd28b6)[lang]?.links || {};
    // Вложенный цикл/генерация для массива ссылок-кнопок
    container.innerHTML = (0, $9337a2b725b875ba$export$cb1f63fb7a693f5e).map((project, index)=>{
        const { title: title, description: description, image: image, imageClass: imageClass, links: links } = project;
        const linksHtml = links.map(({ text: text, className: className, url: url })=>{
            const linkText = t[text] || text;
            return `
            <a rel="noreferrer" target="_blank" class="cta-btn ${className}" href="${url}" data-project-link="${text}">
              ${linkText}
            </a>
          `;
        }).join("");
        const titleText = title[lang] || title["ru"];
        const descText = description[lang] || description["ru"];
        // Возвращаем собранную строку проекта
        return `
        <div class="row" data-project-id="${index}">
          <div class="col-xl-4 col-sm-12">
            <div class="project-wrapper__text load-hidden">
              <h3 class="project-wrapper__text-title" data-project-title>${titleText}</h3>
              <div>
                <p class="mb-4" data-project-desc>${descText}</p>
              </div>
              ${linksHtml}
            </div>
          </div>
          <div class="col-xl-8 col-sm-12">
            <div class="project-wrapper__image load-hidden">
              <div
                data-tilt
                data-tilt-max="4"
                data-tilt-glare="true"
                data-tilt-max-glare="0.5"
                class="thumbnail js-tilt ${imageClass || ""}"
              >
                <img alt="Project Image" class="img-fluid" src="${image}" />
              </div>
            </div>
          </div>
        </div>
      `;
    }).join("");
}
function $1a4136fab1846a2e$export$4c64841ab31c6bb0() {
    const container = document.querySelector("#projects-container");
    if (!container) return;
    const lang = (0, $4307ff1b793d7d7d$export$64783e31db14f0ba)();
    const t = (0, $a85827dfdcfb16a5$export$7540ac15abfd28b6)[lang]?.links || {};
    // Обновление ссылок
    container.querySelectorAll("[data-project-link]").forEach((link)=>{
        const originalText = link.getAttribute("data-project-link");
        link.textContent = t[originalText] || originalText;
    });
    // Обновление текстового контента карточек
    (0, $9337a2b725b875ba$export$cb1f63fb7a693f5e).forEach(({ title: title, description: description }, index)=>{
        const projectRow = container.querySelector(`[data-project-id="${index}"]`);
        if (!projectRow) return;
        const titleEl = projectRow.querySelector("[data-project-title]");
        const descEl = projectRow.querySelector("[data-project-desc]");
        if (titleEl) titleEl.textContent = title[lang] || title["ru"];
        if (descEl) descEl.innerHTML = description[lang] || description["ru"];
    });
}


const $f3bcf4641bf8382d$var$MOON_PATH = "M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z";
const $f3bcf4641bf8382d$var$SUN_PATH = "M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z";
const $f3bcf4641bf8382d$var$THEME_STORAGE_KEY = "theme";
const $f3bcf4641bf8382d$var$DEFAULT_THEME_VARIANT = 2;
function $f3bcf4641bf8382d$var$getStoredThemeVariant() {
    const stored = Number(localStorage.getItem($f3bcf4641bf8382d$var$THEME_STORAGE_KEY));
    return stored === 1 || stored === 2 ? stored : $f3bcf4641bf8382d$var$DEFAULT_THEME_VARIANT;
}
function $f3bcf4641bf8382d$var$applyTheme(themeVariant, themePath) {
    document.body.style.setProperty("--background-color", `var(--background-theme${themeVariant})`);
    document.body.style.setProperty("--color", `var(--color-theme${themeVariant})`);
    document.body.style.setProperty("--grey", `var(--grey-theme${themeVariant})`);
    document.body.style.setProperty("--footer", `var(--footer-theme${themeVariant})`);
    document.querySelectorAll("#about, #why-me, .text-color-main").forEach((el)=>{
        el.style.setProperty("background-image", "initial");
    });
    if (themePath) themePath.setAttribute("d", themeVariant === 1 ? $f3bcf4641bf8382d$var$MOON_PATH : $f3bcf4641bf8382d$var$SUN_PATH);
}
function $f3bcf4641bf8382d$export$4c47704ed26c13e8() {
    const themeButton = document.querySelector(".change-theme");
    if (!themeButton) return; // Защита профессора: если кнопки нет на странице, код не упадет
    const themePath = themeButton.querySelector("path");
    let themeVariant = $f3bcf4641bf8382d$var$getStoredThemeVariant();
    // Применяем сохранённую тему сразу при загрузке, а не только дефолтную
    $f3bcf4641bf8382d$var$applyTheme(themeVariant, themePath);
    function changeTheme() {
        themeVariant = themeVariant === 1 ? 2 : 1;
        localStorage.setItem($f3bcf4641bf8382d$var$THEME_STORAGE_KEY, themeVariant);
        $f3bcf4641bf8382d$var$applyTheme(themeVariant, themePath);
    }
    themeButton.addEventListener("click", changeTheme);
}


const $9da10bb7a3be9416$var$sadCorgi = document.querySelector("#sad-corgi");
const $9da10bb7a3be9416$var$happyCorgi = document.querySelector("#happy-corgi");
function $9da10bb7a3be9416$var$changeMood() {
    if (!$9da10bb7a3be9416$var$happyCorgi.classList.contains("hide")) {
        $9da10bb7a3be9416$var$happyCorgi.classList.add("hide");
        $9da10bb7a3be9416$var$sadCorgi.classList.remove("hide");
    } else {
        $9da10bb7a3be9416$var$happyCorgi.classList.remove("hide");
        $9da10bb7a3be9416$var$sadCorgi.classList.add("hide");
    }
}
function $9da10bb7a3be9416$export$9a487925082b33f1() {
    $9da10bb7a3be9416$var$sadCorgi.addEventListener("click", $9da10bb7a3be9416$var$changeMood);
}


const $3ec6f92cd89ae22c$export$150b732325d14d04 = {
    ru: {
        nav: {
            about: "\u041E\u0431\u043E \u043C\u043D\u0435",
            projects: "\u041F\u0440\u043E\u0435\u043A\u0442\u044B",
            whyMe: "\u041F\u043E\u0447\u0435\u043C\u0443 \u044F?",
            contact: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u044B"
        },
        home: {
            title: "\u041F\u0440\u0438\u0432\u0435\u0442,<br />\u044F",
            subtitle: "\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A",
            description: "\u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u043D\u0440\u0430\u0432\u0438\u0442\u0441\u044F \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435, \u043A\u0440\u0430\u0441\u0438\u0432\u044B\u0435 \u0438 \u0441\u043B\u043E\u0436\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B... \u0438 \u043A\u043E\u0440\u0433\u0438",
            cta: "\u041F\u0440\u043E\u0435\u043A\u0442\u044B"
        },
        about: {
            title: "\u041E\u0431\u043E \u043C\u043D\u0435",
            text1: "\u041C\u0435\u043D\u044F \u0437\u043E\u0432\u0443\u0442 \u0414\u0430\u0432\u043B\u0430\u0442, \u0438 \u0432\u043E\u0442 \u0443\u0436\u0435 5-\u0439 \u0433\u043E\u0434 \u044F \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0441\u044C \u0432\u0435\u0431-\u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u043E\u0439. \u0417\u0430 \u043F\u043B\u0435\u0447\u0430\u043C\u0438 \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u043E \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
            text2: "<span>&#10004;</span> \u041F\u043E\u0433\u0440\u0443\u0436\u0435\u043D \u0432 \u043C\u0438\u0440 Javascript (4+ \u0433\u043E\u0434\u0430). \u0423\u0432\u0435\u0440\u0435\u043D\u043D\u043E\u0435 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 Vue 3, Nuxt 3, Vuex/Pinia, Vite/Webpack, npm/npx \u0438 git.",
            text3: "<span>&#10004;</span> \u041E\u0431\u043B\u0430\u0434\u0430\u044E \u043E\u043F\u044B\u0442\u043E\u043C \u0440\u0430\u0431\u043E\u0442\u044B \u0441 REST API, Websockets, PWA, Axios \u0438 JSON. <br />\u0412\u0435\u0440\u0441\u0442\u0430\u044E \u0430\u0434\u0430\u043F\u0442\u0438\u0432\u043D\u044B\u0435, \u043A\u0440\u043E\u0441\u0441\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u043D\u044B\u0435 \u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u044B, \u043F\u0440\u0438\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u044F\u0441\u044C \u043C\u0435\u0442\u043E\u0434\u043E\u043B\u043E\u0433\u0438\u0438 \u0411\u042D\u041C \u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u044B Tailwind, Sass(SCSS), Bootstrap.",
            text4: "<span>&#10004;</span> \u0425\u043E\u0440\u043E\u0448\u043E \u0437\u043D\u0430\u043A\u043E\u043C c E2E(Playwright), Typescript, React, Redux, Pixi \u0438 Tween.js, GitHub/Gitlab, Figma.",
            text5: "<span>&#10004;</span> \u041C\u0430\u0433\u0438\u0441\u0442\u0440 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043D\u0430\u0443\u043A (2 \u0432\u044B\u0441\u0448\u0438\u0445 \u0442\u0435\u0445. \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F). <br />\u0423\u043C\u0435\u044E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0430\u0437\u0431\u0438\u0440\u0430\u0442\u044C\u0441\u044F \u0432 \u0447\u0443\u0436\u043E\u043C \u043A\u043E\u0434\u0435, \u0431\u044B\u0441\u0442\u0440\u043E \u043E\u0441\u0432\u0430\u0438\u0432\u0430\u044F \u043D\u043E\u0432\u044B\u0435 \u043A\u043E\u043D\u0446\u0435\u043F\u0446\u0438\u0438 \u0438 \u043C\u0435\u0442\u043E\u0434\u043E\u043B\u043E\u0433\u0438\u0438.",
            resume: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0440\u0435\u0437\u044E\u043C\u0435",
            resumeTitle: "\u0410\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430\u044F \u0432\u0435\u0440\u0441\u0438\u044F \u0440\u0435\u0437\u044E\u043C\u0435"
        },
        projects: {
            title: "\u041F\u043E\u0440\u0442\u0444\u043E\u043B\u0438\u043E"
        },
        whyMe: {
            title: "\u041F\u043E\u0447\u0435\u043C\u0443 \u044F?",
            text1: "<span>&#10004;</span> <strong>\u0418\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u0430\u044F \u0431\u0430\u0437\u0430:</strong> 2 \u0432\u044B\u0441\u0448\u0438\u0445 \u0442\u0435\u0445. \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F (\u0432 \u0442.\u0447. \u0418\u043D\u0436\u0435\u043D\u0435\u0440 \u0418\u0418) \u0438 \u0434\u043E\u043F. \u043A\u0443\u0440\u0441\u044B (Ulbi TV, JavaScript.Ninja) \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043B\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0439 \u043F\u043E\u0434\u0445\u043E\u0434, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0449\u0438\u0439 \u043C\u043D\u0435 \u0430\u0432\u0442\u043E\u043D\u043E\u043C\u043D\u043E \u0438 \u0431\u044B\u0441\u0442\u0440\u043E \u0440\u0435\u0448\u0430\u0442\u044C \u0437\u0430\u0434\u0430\u0447\u0438.",
            text2: "<span>&#10004;</span> <strong>\u0418\u043D\u0436\u0435\u043D\u0435\u0440\u043D\u044B\u0439 \u043F\u043E\u0434\u0445\u043E\u0434:</strong> \u041F\u0440\u0430\u043A\u0442\u0438\u043A\u0443\u044E \u043E\u0441\u043E\u0437\u043D\u0430\u043D\u043D\u043E\u0435 \u0432\u043D\u0435\u0434\u0440\u0435\u043D\u0438\u0435 \u043D\u0435\u0439\u0440\u043E\u0441\u0435\u0442\u0435\u0439, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0438\u0445 \u0434\u043B\u044F \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0438 TTM, \u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044F \u0437\u0430 \u0441\u043E\u0431\u043E\u0439 \u0430\u0440\u0445\u0438\u0442\u0435\u043A\u0442\u0443\u0440\u0443 \u0438 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0430.",
            text3: "<span>&#10004;</span> <strong>\u0420\u0430\u0431\u043E\u0442\u0430 \u0441 legacy \u0438 \u0447\u0443\u0436\u0438\u043C \u043A\u043E\u0434\u043E\u043C:</strong> \u0417\u0430 \u0433\u043E\u0434\u044B \u043F\u0440\u0430\u043A\u0442\u0438\u043A\u0438 \u044F \u0443\u0447\u0430\u0441\u0442\u0432\u043E\u0432\u0430\u043B \u0432 \u0441\u0430\u043C\u044B\u0445 \u0440\u0430\u0437\u043D\u044B\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445 \u2014 \u043E\u0442 \u0441\u0442\u0430\u0440\u0442\u0430\u043F\u043E\u0432 \u0434\u043E \u0441\u043B\u043E\u0436\u043D\u044B\u0445 \u044D\u043A\u043E\u0441\u0438\u0441\u0442\u0435\u043C. \u0411\u044B\u0441\u0442\u0440\u043E \u0440\u0430\u0437\u0431\u0438\u0440\u0430\u044E\u0441\u044C \u0432 \u0447\u0443\u0436\u043E\u043C \u043A\u043E\u0434\u0435, \u043F\u0440\u043E\u0432\u043E\u0436\u0443 \u0440\u0435\u0444\u0430\u043A\u0442\u043E\u0440\u0438\u043D\u0433, \u0441\u043E\u0445\u0440\u0430\u043D\u044F\u044F \u0435\u0451 \u0440\u0430\u0431\u043E\u0442\u043E\u0441\u043F\u043E\u0441\u043E\u0431\u043D\u043E\u0441\u0442\u044C.",
            text4: "<span>&#10004;</span> <strong>\u041F\u0440\u043E\u0434\u0443\u043A\u0442 \u0432\u0430\u0436\u043D\u0435\u0435 \u043A\u043E\u0434\u0430:</strong> \u041C\u043D\u0435 \u043D\u0435 \u0432\u0441\u0451 \u0440\u0430\u0432\u043D\u043E, \u043D\u0430\u0434 \u0447\u0435\u043C \u044F \u0440\u0430\u0431\u043E\u0442\u0430\u044E. \u042F \u0432\u0441\u0435\u0433\u0434\u0430 \u043F\u043E\u0433\u0440\u0443\u0436\u0430\u044E\u0441\u044C \u0432 \u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043D\u0438\u043C\u0430\u0442\u044C, \u0437\u0430\u0447\u0435\u043C \u043C\u044B \u044D\u0442\u043E \u0434\u0435\u043B\u0430\u0435\u043C."
        },
        contact: {
            title: "\u0421\u0432\u044F\u0437\u0430\u0442\u044C\u0441\u044F \u0441\u043E \u043C\u043D\u043E\u0439:"
        },
        footer: {
            text: "\xa9 2023 - Developed by"
        }
    },
    en: {
        nav: {
            about: "About me",
            projects: "Projects",
            whyMe: "Why me?",
            contact: "Contact"
        },
        home: {
            title: "Hi,<br />I'm",
            subtitle: "developer",
            description: "who enjoys creating functional, beautiful, and complex interfaces... and corgis",
            cta: "Projects"
        },
        about: {
            title: "About me",
            text1: "My name is Davlat, and I've been working in web development for 5 years now. I have many interesting projects under my belt.",
            text2: "<span>&#10004;</span> Deeply immersed in JavaScript (4+ years). Proficient in Vue 3, Nuxt 3, Vuex/Pinia, Vite/Webpack, npm/npx, and git.",
            text3: "<span>&#10004;</span> Experience with REST API, Websockets, PWA, Axios, and JSON. <br />I create responsive, cross-browser interfaces using BEM methodology and tools like Tailwind, Sass(SCSS), and Bootstrap.",
            text4: "<span>&#10004;</span> Familiar with E2E(Playwright), Typescript, React, Redux, Pixi, Tween.js, GitHub/Gitlab, and Figma.",
            text5: "<span>&#10004;</span> Master of Technical Sciences (2 technical degrees). <br />I can quickly understand other people's code and master new concepts and methodologies.",
            resume: "View Resume",
            resumeTitle: "Latest resume version"
        },
        projects: {
            title: "Portfolio"
        },
        whyMe: {
            title: "Why me?",
            text1: "<span>&#10004;</span> <strong>Engineering foundation:</strong> 2 technical degrees (including AI Engineer) and additional courses (Ulbi TV, JavaScript.Ninja) have developed a systematic approach that allows me to work autonomously and solve tasks quickly.",
            text2: "<span>&#10004;</span> <strong>Engineering approach:</strong> I practice conscious AI integration, using them to speed up development and TTM while retaining architecture and quality control.",
            text3: "<span>&#10004;</span> <strong>Working with legacy and other people's code:</strong> Over the years, I've worked on various projects \u2014 from startups to complex ecosystems. I quickly understand other people's code and perform refactoring while maintaining functionality.",
            text4: "<span>&#10004;</span> <strong>Product matters more than code:</strong> I care about what I work on. I always immerse myself in the company's business processes to understand why we're doing this."
        },
        contact: {
            title: "Contact me:"
        },
        footer: {
            text: "\xa9 2023 - Developed by"
        }
    }
};




function $d07a8778564770fa$var$updatePageLanguage(lang) {
    const t = (0, $3ec6f92cd89ae22c$export$150b732325d14d04)[lang];
    document.documentElement.lang = lang;
    // Обновляем элементы с data-i18n атрибутами
    document.querySelectorAll("[data-i18n]").forEach((el)=>{
        const key = el.getAttribute("data-i18n");
        const value = $d07a8778564770fa$var$getNestedValue(t, key);
        if (value !== undefined) {
            // Если в значении есть HTML теги, используем innerHTML
            if (/<[a-z][\s\S]*>/i.test(value)) el.innerHTML = value;
            else el.textContent = value;
        }
    });
    // Обновляем кнопки с data-i18n-btn
    document.querySelectorAll("[data-i18n-btn]").forEach((el)=>{
        const key = el.getAttribute("data-i18n-btn");
        const value = $d07a8778564770fa$var$getNestedValue(t, key);
        if (value !== undefined) el.textContent = value;
    });
    // Обновляем placeholder и другие атрибуты
    document.querySelectorAll("[data-i18n-attr]").forEach((el)=>{
        const key = el.getAttribute("data-i18n-attr");
        const attr = el.getAttribute("data-i18n-attr-name") || "placeholder";
        const value = $d07a8778564770fa$var$getNestedValue(t, key);
        if (value !== undefined) el.setAttribute(attr, value);
    });
    // Обновляем текст на самой кнопке переключения языков
    const langBtn = document.querySelector("[data-lang-btn]");
    if (langBtn) langBtn.textContent = lang === "ru" ? "EN" : "RU";
}
function $d07a8778564770fa$var$getNestedValue(obj, path) {
    return path.split(".").reduce((current, key)=>current?.[key], obj);
}
function $d07a8778564770fa$export$4b6bf64406ec64af(lang) {
    localStorage.setItem((0, $4307ff1b793d7d7d$export$b110f9681740cce), lang);
    $d07a8778564770fa$var$updatePageLanguage(lang);
    (0, $1a4136fab1846a2e$export$4c64841ab31c6bb0)();
}
function $d07a8778564770fa$export$8464cdd050ea8737() {
    const lang = (0, $4307ff1b793d7d7d$export$64783e31db14f0ba)();
    // Обновляем статичный перевод страницы и карточки проектов
    $d07a8778564770fa$var$updatePageLanguage(lang);
    (0, $1a4136fab1846a2e$export$4c64841ab31c6bb0)();
    // Инициализируем кнопку переключения языка
    const langBtn = document.querySelector("[data-lang-btn]");
    if (langBtn) langBtn.addEventListener("click", (e)=>{
        e.preventDefault();
        const currentLang = (0, $4307ff1b793d7d7d$export$64783e31db14f0ba)();
        const newLang = currentLang === "ru" ? "en" : "ru";
        $d07a8778564770fa$export$4b6bf64406ec64af(newLang);
    });
}


// Рендерим элементы в DOM ДО запуска ScrollReveal и VanillaTilt
(0, $1a4136fab1846a2e$export$84595048c9b04d69)();
// Инициализируем переводы и сразу обновляем динамические карточки
(0, $d07a8778564770fa$export$8464cdd050ea8737)();
// Навешиваем эффекты на уже готовый и переведенный DOM
// Плавный скролл
(0, $6f019d1f45ba2738$export$2e2bcd8739ae039)((0, $d859da13df4a30ff$export$adcf75ad64a03007), (0, $d859da13df4a30ff$export$9c21a3269931e1e6));
(0, $b8855ed206bb3c2e$export$2e2bcd8739ae039)();
(0, $f3bcf4641bf8382d$export$4c47704ed26c13e8)(); // иниц. тем
(0, $9da10bb7a3be9416$export$9a487925082b33f1)(); // Запускаем смену настроения корги
// Слушатели событий
// Вешаем события клик для кнопок меню
document.querySelectorAll("svg.nav__toggle, a.nav__link").forEach((button)=>{
    button.addEventListener("click", (0, $d17ec4acc561ff09$export$2e2bcd8739ae039));
});
// меняем направление корги
const $35da740d59af89ba$var$animationDuration = 30000; // ms
setInterval((0, $549936df23f95449$export$2e2bcd8739ae039), $35da740d59af89ba$var$animationDuration);


//# sourceMappingURL=index.59ab3562.js.map
